import * as React from 'react';
import styled from 'styled-components';

type Props = {
    children: React.ReactNode;
    className?: string;
    testid?: string;
};

const FavoriteNoResults = ({ children, className = '', testid }: Props) => {
    return (
        <StyledNoResults
            className={className}
            data-testid={testid}
        >
            {children}
        </StyledNoResults>
    );
};

export default FavoriteNoResults;

const StyledNoResults = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-left: 1px solid ${({ theme }) => theme.colors.blueLight};
    border-right: 1px solid ${({ theme }) => theme.colors.blueLight};
    border-bottom: 1px solid ${({ theme }) => theme.colors.blueLight};
    text-align: center;
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: 0.2px;
    color: ${({ theme }) => theme.colors.grey100};
    margin-left: 0;
    padding: 32px;
`;
